import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { exchangeAutoSettingsApi } from '../services';
import { AutoExchangeSettings } from '../../types';

export interface AutoSettingsListState {
  autoSettings?: AutoExchangeSettings[];
  pagination?: Pagination;
  errorsList?: string;
}

const initialState: AutoSettingsListState = {};

export const autoSettingsListSlice = createSlice({
  name: 'autoSettings',
  initialState,
  reducers: {
    clearAutoSettingsListState: (state) => {
      state.autoSettings = undefined;
      state.pagination = undefined;
      state.errorsList = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.getExchangeAutoSettings.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.getExchangeAutoSettings.matchRejected,
      (state, action: any) => {
        state.autoSettings = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.getExchangeAutoSettings.matchFulfilled,
      (state, action: PayloadAction<Response<AutoExchangeSettings>>) => {
        state.autoSettings = action.payload.data.edges.map((item) => ({
          ...item.node,
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.changeSettingsStatus.matchFulfilled,
      (state, action: PayloadAction<{ data: AutoExchangeSettings }>) => {
        state.autoSettings = state.autoSettings?.map((item) => {
          const result = { ...item };

          if (result.id === action.payload.data.id) {
            result.active = action.payload.data.active;
          }

          return result;
        });
      },
    );
    builder.addMatcher(
      exchangeAutoSettingsApi.endpoints.updateExchangeAutoSettingsPair
        .matchFulfilled,
      (state, action: PayloadAction<{ data: AutoExchangeSettings }>) => {
        state.autoSettings = state.autoSettings?.map((item) => {
          let result = { ...item };

          if (result.id === action.payload.data.id) {
            result = action.payload.data;
          }

          return result;
        });
      },
    );
  },
});

export const { clearAutoSettingsListState } = autoSettingsListSlice.actions;

export default autoSettingsListSlice.reducer;
